/* ============================================================
   The Squishy Box — Product page v2
   Bundle selector drives Horizon's native product form (real
   add-to-cart + cart drawer). Plus sticky bar + gallery.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('.sb2-pdp-root');

  function theForm() {
    return document.querySelector('.sb2-pdp-root [data-type="add-to-cart-form"]')
        || document.querySelector('.sb2-pdp-root form');
  }

  /* ---- Bundle selector ---------------------------------------------- */
  function initBundles() {
    if (!root) return;
    var form = theForm();
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var qtyInput = form ? form.querySelector('[name="quantity"]') : null;
    var bundles = Array.prototype.slice.call(root.querySelectorAll('.sb2-bundle'));

    function select(b) {
      if (!b || b.getAttribute('data-unavailable') === 'true') return;
      bundles.forEach(function (x) { x.classList.remove('sb2-sel'); });
      b.classList.add('sb2-sel');
      var vid = b.getAttribute('data-variant-id');
      var qty = b.getAttribute('data-qty') || '1';
      var price = b.getAttribute('data-price-formatted') || '';
      var was = b.getAttribute('data-compare-formatted') || '';
      if (idInput && vid) idInput.value = vid;
      if (qtyInput) qtyInput.value = qty;
      document.querySelectorAll('[data-sb2-price]').forEach(function (el) { el.textContent = price; });
      document.querySelectorAll('[data-sb2-was]').forEach(function (el) { el.textContent = was; el.style.display = was ? '' : 'none'; });
      if (vid) { try { var u = new URL(window.location.href); u.searchParams.set('variant', vid); history.replaceState({}, '', u); } catch (e) {} }
    }

    bundles.forEach(function (b) { b.addEventListener('click', function () { select(b); }); });
    select(root.querySelector('.sb2-bundle.sb2-sel') || bundles[0]);

    // Bulletproof: force the selected variant + quantity at submit time
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || (f.getAttribute && f.getAttribute('data-type') !== 'add-to-cart-form')) return;
      var sel = root.querySelector('.sb2-bundle.sb2-sel');
      if (!sel) return;
      var vid = sel.getAttribute('data-variant-id');
      var qty = sel.getAttribute('data-qty') || '1';
      var i = f.querySelector('[name="id"]'); if (i && vid) i.value = vid;
      var q = f.querySelector('[name="quantity"]'); if (q) q.value = qty;
      if (vid) { try { var u = new URL(window.location.href); u.searchParams.set('variant', vid); history.replaceState({}, '', u); } catch (err) {} }
    }, true);

    // Secondary add buttons (sticky / final) trigger the form
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-sb2-add]') : null;
      if (!btn || !form) return;
      if (form.contains(btn)) return; // in-form submit button handles itself
      e.preventDefault();
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  }

  /* ---- Sticky bar reveal -------------------------------------------- */
  function initSticky() {
    var bar = document.getElementById('sb2-stickyBar');
    if (!bar) return;
    document.body.classList.add('sb2-pad');
    window.addEventListener('scroll', function () { bar.classList.toggle('sb2-show', window.scrollY > 620); }, { passive: true });
  }

  /* ---- Gallery thumbnails ------------------------------------------- */
  function initGallery() {
    var main = root && root.querySelector('.sb2-main img');
    var thumbs = root ? root.querySelectorAll('.sb2-thumb[data-full]') : [];
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        if (full) main.src = full;
        root.querySelectorAll('.sb2-thumb').forEach(function (x) { x.classList.remove('sb2-active'); });
        t.classList.add('sb2-active');
      });
    });
  }

  function init() { initBundles(); initSticky(); initGallery(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
